


































































import { Vue, Component, Watch } from "vue-property-decorator";
import CallBuffer from "./CallBuffer.vue";
import { State, Action } from "vuex-class";
import { User } from "@/types";
import logger from "@/configs/logger";

@Component({ components: { CallBuffer } })
export default class IncomingCallDialog extends Vue {
  @State("ringing") ringing!: boolean;
  @State("currentTask") currentTask!: any;
  @State("taskAttributes") taskAttributes!: any;
  @State("user") user!: User;
  @State("config") config!: any;
  @Action("acceptReservation") acceptReservation!: Function;

  @Watch("ringing")
  onRingingChange(val: any, prevVal: any) {
    if (val) {
      window.addEventListener("keypress", this.acceptCallWithKeyPress);
      this.$modal.show("call_dialog");
    } else {
      this.$modal.hide("call_dialog");
      window.removeEventListener("keypress", this.acceptCallWithKeyPress);
    }
  }

  get attributes() {
    return this.taskAttributes || {};
  }

  handleAcceptCall(accept: boolean) {
    this.acceptReservation({ accept });
  }

  acceptCallWithKeyPress(e: KeyboardEvent) {
    if (e.code !== "Space") return;
    this.handleAcceptCall(true);
  }

  beforeDestroy() {
    // only called when layouts/app is unmounted
    window.removeEventListener("keypress", this.acceptCallWithKeyPress);
  }
}
